import { DynamicComponentLoaderModule } from '@adaptiva/core/loaders';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ForgotPasswordOverlayComponent } from './forgot-password-overlay.component';

@NgModule({
	imports: [
		AlertComponentModule,
		CommonModule,
		ContainerComponentModule,
		DynamicComponentLoaderModule.forChild(ForgotPasswordOverlayComponent),
		InputComponentModule,
		LabelComponentModule
	],
	declarations: [ForgotPasswordOverlayComponent],
	exports: [ForgotPasswordOverlayComponent],
})
export class ForgotPasswordOverlayModule {

}
